// Docs
// https://marmelab.com/react-admin/Show.html#actions
// https://github.com/marmelab/react-admin/blob/master/docs/Actions.md
// https://reactjs.org/docs/conditional-rendering.html

import React from 'react';
import { TextInput } from 'react-admin';
import ListHeaderWithFilters from '../../../components/ListHeaderWithFilters';


const ListHeader = props => (
  <ListHeaderWithFilters
    {...props}
    title="Mobile Consent Solutions"
    subtitle="Here you can create a new Mobile Consent Solution or change one of your existing Mobile Consent Solutions."
    createBtnLabel="mobile_consent_solution_create"
    createBtnLabelSmall="mobile_consent_solution_create_small">
    <TextInput
      label="Search by consent solution"
      source="name"
      alwaysOn
      fullWidth={true}
    />
  </ListHeaderWithFilters>
);

export default ListHeader;
